module.exports = __webpack_public_path__ + "static/media/1-9.82e40d69.webp";